import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ServiceDetails } from "../../types/General";
import { useLazyGetServiceByIdQuery } from "../../service/services";
import { showError } from "../../constants/toasts";
import { formatDuration } from "../../utils/commonFunctions";
import Loader from "../../constants/Loader";
import { PRICE_TYPE } from "../../utils/enums";
import dayjs from "dayjs";

const dayMap = {
  mon: "Monday",
  tue: "Tuesday",
  wed: "Wednesday",
  thu: "Thursday",
  fri: "Friday",
  sat: "Saturday",
  sun: "Sunday",
};

const ViewService = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [service, setService] = useState<ServiceDetails | null>(null);

  const [getServiceById, { isLoading }] = useLazyGetServiceByIdQuery();

  const getServiceByIdApi = async () => {
    try {
      const response = await getServiceById({
        id,
      }).unwrap();
      if (response.statusCode === 200) {
        const data: ServiceDetails = response?.data;
        setService(data);

        // Initialize images state
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };



  useEffect(() => {
    if (id) {
      getServiceByIdApi();
    }
  }, [id]);

  return (
    <>
      <Loader isLoad={isLoading} />
      <div className="main_title">
        <h1>Service Details</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate(-1)}>Manage Services</button> -
          Service Detail
        </p>
      </div>

      <div className="cards view_page">
        {/* Service Info */}
        <div className="gap_p">
          <div className="w_33">
            {" "}
            <h6>Service Name:</h6>
            <p>{service?.name || "-"}</p>
          </div>
          <div className="w_33">
            {" "}
            <h6>Service Description:</h6>
            <p>{service?.description || "-"}</p>
          </div>
          <div className="w_33">
            {" "}
            <h6>Service Price:</h6>
            <p>$ {service?.price || "0"}</p>
          </div>
          <div className="w_33">
            {" "}
            <h6>Price Type:</h6>
            <p>
              {Number(service?.priceType) === PRICE_TYPE.HOURLY
                ? "Hourly"
                : Number(service?.priceType) === PRICE_TYPE.FIXED
                  ? "Fixed"
                  : "Package"}
            </p>
          </div>
          <div className="w_33">
            {" "}
            <h6>Tax (if applicable):</h6>
            <p>{service?.tax || "-"}</p>
          </div>
          <div className="w_33">
            {" "}
            <h6>Maximum Bookings Per Slot/Day:</h6>
            <p>{service?.maxLimit || "-"}</p>
          </div>

          <div className="w_33">
            <h6>Category</h6>
            <p>{service?.category?.name || "-"}</p>
          </div>
          <div className="w_33">
            <h6>Sub-category</h6>
            <p>{service?.subCategory?.name || "-"}</p>
          </div>
          <div className="w_33">
            <h6>Duration</h6>
            <p>{formatDuration(service?.slotTime || 0) || "-"}</p>
          </div>
          <div className="w_100">
            <h6>Availability</h6>
            {service?.availability?.map((pattern: any, index: number) => {
              const days = (Object.keys(dayMap) as (keyof typeof dayMap)[])
                .filter((day) => pattern[day])
                .map((day) => dayMap[day])
                .join(", ");
              
              const startTime = pattern.startTime ? dayjs(pattern.startTime).local().format("hh:mm A") : "-";
              const endTime = pattern.endTime ? dayjs(pattern.endTime).local().format("hh:mm A") : "-";

              return (
                <div key={index} style={{ marginBottom: "8px" }}>
                  <p style={{ margin: 0 }}>
                    <strong>Pattern {index + 1}:</strong> {days || "No days selected"}
                  </p>
                  <p style={{ margin: 0, color: "#666" }}>
                    Time: {startTime} - {endTime}
                  </p>
                </div>
              );
            })}
            {(service?.availability?.length ?? 0) === 0 && <p>-</p>}
          </div>
         

          <div className="w_100">
            <h6>Optional Extras or Add-ons</h6>
            <p>{service?.addOns || "-"}</p>
          </div>
          <div className="w_100">
            <h6>Service Images</h6>
            <div className="gap_p" style={{ marginTop: "10px" }}>
              {(service?.media?.length ?? 0) > 0 ? (
                service?.media?.map((media: any, index: number) => {
                  return (
                    <div className="w_25" key={index} style={{ marginBottom: "16px" }}>
                      <figure style={{ margin: 0, overflow: "hidden", borderRadius: "8px" }}>
                        <img
                          src={media?.url}
                          alt={`Service ${index + 1}`}
                          style={{ width: "100%", height: "200px", objectFit: "cover" }}
                        />
                      </figure>
                    </div>
                  );
                })
              ) : (
                <p>No images available</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ViewService;
